// src/ui/BubbleTail.jsx — the exact WhatsApp/iMessage-style curved "beak" from the
// mobile app (src/components/BubbleTail.tsx), ported 1:1 so web and phone match.
// Same SVG paths, same 8×13 viewBox, same -6px outer offset, absolutely positioned so
// it never affects layout.
import React from 'react';

const D_RIGHT = 'M6.467 10.432 L0 2 V13 H5.188 C6.958 13 7.526 11.844 6.467 10.432 Z';
const D_LEFT  = 'M1.533 10.432 L8 2 V13 H2.812 C1.042 13 0.474 11.844 1.533 10.432 Z';

export default function BubbleTail({ side = 'right', color, offset = -6, bottom = 0 }) {
  return (
    <svg
      width={13}
      height={19}
      viewBox="0 0 8 13"
      style={{
        position: 'absolute',
        bottom,
        ...(side === 'right' ? { right: offset } : { left: offset }),
        pointerEvents: 'none',
        overflow: 'visible',
      }}
    >
      <path d={side === 'right' ? D_RIGHT : D_LEFT} fill={color} />
    </svg>
  );
}
